import CustomTips from "components/base/CustomTips";
import { CustomTitleLabel, CustomTitleWithRadio } from "components/earning/CustomBaseComponments";
import { LanguageConfig } from "config/CustomEnums";
import i18n from "I18n";
import React from "react";
import { useFormContext } from "react-hook-form";

const FeaturedOrExclusiveCampaignRadio = ({
  language,
}) => {

  const {watch, setValue} = useFormContext();

  const isExclusive = watch("isExclusive")
  const isFeatured = watch("isFeatured")
  const CampaignLabel = {
    none: 'none',
    isFeatured: 'isFeatured',
    isExclusive: 'isExclusive',
  };

  const getRadioOptions = (language) => [
    {
      label: i18n.t('campaign.none', { locale: language }),
      value: CampaignLabel.none,
    },
    {
      label: i18n.t('campaign.featured_campaign', { locale: language }),
      value: CampaignLabel.isFeatured,
    },
    {
      label: i18n.t('campaign.exclusive_campaign', { locale: language }),
      value: CampaignLabel.isExclusive,
    },
  ];
  const getDefaultLabel = () => {
    if (isExclusive) {
      return CampaignLabel.isExclusive;
    }
    if (isFeatured) {
      return CampaignLabel.isFeatured;
    }
    return CampaignLabel.none;
  };
  const getRadioText = () => {
    let label = CampaignLabel.none;
    if (isFeatured) {
      label = CampaignLabel.isFeatured;
    }
    if (isExclusive) {
      label = CampaignLabel.isExclusive;
    }
    return radioOptions.filter((item) => item.value === label)[0].label;
  };

  const radioOptions = getRadioOptions(language);
  return (
    <>
      {language === LanguageConfig.english
        ? <CustomTitleWithRadio
          title={i18n.t('campaign.featured_or_exclusive_campaign', { locale: language, })}
          popoverTips={i18n.t('campaign.featured_or_exclusive_campaign_tips', { locale: language, })}
          options={radioOptions}
          disabled={language !== LanguageConfig.english}
          defaultValue={getDefaultLabel()}
          setValue={(value) => {
            setValue('campaignLabelType', value, { shouldDirty: true });
            setValue('isFeatured', CampaignLabel.isFeatured === value, {
              shouldDirty: true,
            });
            setValue('isExclusive', CampaignLabel.isExclusive === value, {
              shouldDirty: true,
            });
          }}
        />
        : <>
          <CustomTips
            detail={i18n.t('campaign.featured_or_exclusive_campaign_tips', {
              locale: language,
            })}
            customClass={{ area: "create-section-label-bottom-space" }}
          >
            <CustomTitleLabel title={i18n.t('campaign.featured_or_exclusive_campaign', {
              locale: language,
            })}
              className={"featured-exclusive-row-tip-label"}
            />
          </CustomTips>
          {getRadioText()}
        </>}
    </>
  )
}

export default FeaturedOrExclusiveCampaignRadio;